import { render, staticRenderFns } from "./changeQPwd.vue?vue&type=template&id=0a782670"
import script from "./changeQPwd.vue?vue&type=script&lang=js"
export * from "./changeQPwd.vue?vue&type=script&lang=js"
import style0 from "./changeQPwd.vue?vue&type=style&index=0&id=0a782670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports